/* ============================================================
   Craftier — appointment booking

   Flow:
     store -> type · store · slot · details   (4 steps)
     video -> type · slot · details           (3 steps)

   Everything configurable lives in window.CRAFTIER (stores, opening
   hours, slot length, lead time, occasions). Nothing hardcoded here.

   Ends by handing off to WhatsApp with the full booking prefilled,
   including the store address and Google Maps link.
   ============================================================ */

(function () {
  'use strict';

  var root = document.getElementById('cr-booking');
  if (!root) return;

  var CFG = function () { return window.CRAFTIER || {}; };
  var B = function () { return CFG().booking || {}; };
  var STORES = function () { return CFG().stores || []; };

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'];

  var TITLES = {
    type: 'How would you like to meet?',
    store: 'Pick a store',
    slot: 'Choose a date & time',
    details: 'Your details'
  };

  var LABELS = {
    type: 'Appointment<br>Type',
    store: 'Select<br>Store',
    slot: 'Choose<br>Slot',
    details: 'Your<br>Details'
  };

  /* ---------- state ---------- */
  var state = { type: null, storeId: null, date: null, time: null };
  var view = new Date();          // month the calendar is showing
  var stepIndex = 0;
  var lastFocus = null;

  function steps() {
    return state.type === 'store'
      ? ['type', 'store', 'slot', 'details']
      : ['type', 'slot', 'details'];
  }

  function currentStep() { return steps()[stepIndex]; }

  function store() {
    return STORES().find(function (s) { return s.id === state.storeId; }) || null;
  }

  /* ---------- small helpers ---------- */

  function el(sel, scope) { return (scope || root).querySelector(sel); }
  function els(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
  function digits(v) { return String(v || '').replace(/\D/g, ''); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function midnight(d) { var x = new Date(d); x.setHours(0, 0, 0, 0); return x; }

  function longDate(d) {
    try {
      return new Intl.DateTimeFormat('en-IN', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'
      }).format(d);
    } catch (e) { return d.toDateString(); }
  }

  /* 13.5 -> "1:30 PM" */
  function clock(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12; if (hh === 0) hh = 12;
    return hh + ':' + pad(m) + ' ' + ap;
  }

  function slotLabel(startMins) {
    return clock(startMins) + ' – ' + clock(startMins + (Number(B().slotMinutes) || 30));
  }

  /* ---------- open / close ---------- */

  function open(preset) {
    lastFocus = document.activeElement;
    state = { type: null, storeId: null, date: null, time: null };
    stepIndex = 0;
    view = new Date();

    root.hidden = false;
    document.body.style.overflow = 'hidden';

    if (preset === 'store' || preset === 'video') pickType(preset);
    else render();

    setTimeout(function () {
      var f = el('.crb__step:not([hidden]) button, .crb__step:not([hidden]) select, .crb__step:not([hidden]) input');
      if (f) f.focus();
    }, 60);
  }

  function close() {
    root.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- render ---------- */

  function render() {
    var list = steps();
    var active = currentStep();

    /* step rail */
    var rail = el('[data-crb-rail]');
    rail.innerHTML = '';
    list.forEach(function (name, i) {
      var li = document.createElement('li');
      li.className = 'crb__rail-item' +
        (i < stepIndex ? ' is-done' : '') + (i === stepIndex ? ' is-on' : '');
      li.innerHTML = '<span class="crb__rail-num">' + (i < stepIndex ? '&#10003;' : (i + 1)) + '</span>' +
                     '<span class="crb__rail-label">' + LABELS[name] + '</span>';
      rail.appendChild(li);
    });

    el('[data-crb-title]').innerHTML = (stepIndex + 1) + '. ' + TITLES[active];

    els('.crb__step').forEach(function (s) {
      s.hidden = s.dataset.crbStep !== active;
    });

    if (active === 'store') renderStore();
    if (active === 'slot') { renderCalendar(); renderSlots(); }
    if (active === 'details') renderSummary();

    syncNext();
    var panel = el('.crb__panel');
    if (panel) panel.scrollTop = 0;
  }

  function syncNext() {
    var active = currentStep();
    var btn = el('.crb__step[data-crb-step="' + active + '"] [data-crb-next]');
    if (!btn) return;
    if (active === 'store') btn.disabled = !state.storeId;
    if (active === 'slot') btn.disabled = !(state.date && state.time !== null);
  }

  /* ---------- step: type ---------- */

  function pickType(type) {
    state.type = type;
    state.storeId = null;
    stepIndex = 1;
    render();
  }

  /* ---------- step: store ---------- */

  function renderStore() {
    var sel = el('[data-crb-store]');
    if (sel.options.length <= 1) {
      STORES().forEach(function (s) {
        var o = document.createElement('option');
        o.value = s.id;
        o.textContent = s.name;
        sel.appendChild(o);
      });
    }
    sel.value = state.storeId || '';
    showStoreCard();
  }

  function showStoreCard() {
    var card = el('[data-crb-storecard]');
    var s = store();
    if (!s) { card.hidden = true; return; }
    card.textContent = s.address;
    card.hidden = false;
  }

  /* ---------- step: slot ---------- */

  function renderCalendar() {
    var grid = el('[data-crb-days]');
    grid.innerHTML = '';
    el('[data-crb-month]').textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();

    var first = new Date(view.getFullYear(), view.getMonth(), 1);
    var days = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
    var today = midnight(new Date());
    var max = midnight(new Date());
    max.setDate(max.getDate() + (Number(B().maxDaysAhead) || 60));

    for (var b = 0; b < first.getDay(); b++) {
      grid.appendChild(document.createElement('span'));
    }

    for (var d = 1; d <= days; d++) {
      var date = new Date(view.getFullYear(), view.getMonth(), d);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'crb__day';
      btn.textContent = d;

      var disabled = date < today || date > max || !slotsFor(date).length;
      if (disabled) {
        btn.disabled = true;
      } else {
        btn.dataset.crbDay = ymd(date);
        if (state.date === ymd(date)) btn.classList.add('is-on');
      }
      grid.appendChild(btn);
    }

    /* month arrows */
    var prev = el('[data-crb-prev]');
    var pm = new Date(view.getFullYear(), view.getMonth(), 1);
    prev.disabled = pm <= new Date(today.getFullYear(), today.getMonth(), 1);
    var nm = new Date(view.getFullYear(), view.getMonth() + 1, 1);
    el('[data-crb-next-month]').disabled = nm > max;
  }

  /* Every slot start (in minutes from midnight) still bookable on `date`. */
  function slotsFor(date) {
    var cfg = B();
    var open = (Number(cfg.openHour) || 11) * 60;
    var close = (Number(cfg.closeHour) || 18) * 60;
    var step = Number(cfg.slotMinutes) || 30;
    var lead = (Number(cfg.leadHours) || 0) * 60;

    var out = [];
    var now = new Date();
    var isToday = ymd(date) === ymd(now);
    var cutoff = now.getHours() * 60 + now.getMinutes() + lead;

    for (var t = open; t + step <= close; t += step) {
      if (isToday && t < cutoff) continue;
      out.push(t);
    }
    return out;
  }

  function renderSlots() {
    var wrap = el('[data-crb-slots]');
    var hint = el('[data-crb-slot-hint]');
    wrap.innerHTML = '';

    if (!state.date) { hint.hidden = true; return; }

    var parts = state.date.split('-');
    var date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    var list = slotsFor(date);

    hint.hidden = list.length > 0;

    list.forEach(function (mins) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'crb__slot' + (state.time === mins ? ' is-on' : '');
      b.dataset.crbSlot = mins;
      b.textContent = clock(mins);
      wrap.appendChild(b);
    });
  }

  /* ---------- step: details ---------- */

  function renderSummary() {
    var dl = el('[data-crb-summary]');
    dl.innerHTML = '';

    var parts = state.date.split('-');
    var date = new Date(+parts[0], +parts[1] - 1, +parts[2]);

    var rows = [];
    if (state.type === 'store') {
      var s = store();
      rows.push(['Appointment type', 'Visit a store']);
      if (s) { rows.push(['Store', s.name]); rows.push(['Address', s.address]); }
    } else {
      rows.push(['Appointment type', 'Live video call']);
    }
    rows.push(['Date', longDate(date)]);
    rows.push(['Time', slotLabel(state.time)]);

    rows.forEach(function (r) {
      var dt = document.createElement('dt'); dt.textContent = r[0];
      var dd = document.createElement('dd'); dd.textContent = r[1];
      dl.appendChild(dt); dl.appendChild(dd);
    });

    var occ = el('[data-crb-occasion]');
    if (occ.options.length <= 1) {
      (B().occasions || []).forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o; opt.textContent = o;
        occ.appendChild(opt);
      });
    }
  }

  function say(text, kind) {
    var m = el('[data-crb-msg]');
    m.textContent = text || '';
    m.className = 'crb__msg' + (kind ? ' crb__msg--' + kind : '');
  }

  function confirm() {
    var name = (el('[data-crb-name]').value || '').trim();
    var phone = digits(el('[data-crb-phone]').value);
    var email = (el('[data-crb-email]').value || '').trim();
    var occasion = el('[data-crb-occasion]').value;
    var notes = (el('[data-crb-notes]').value || '').trim();

    if (name.length < 2) return say('Please enter your full name.', 'err');
    if (!/^[6-9]\d{9}$/.test(phone)) return say('Enter a valid 10-digit mobile number.', 'err');
    if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return say('That email address does not look right.', 'err');

    var parts = state.date.split('-');
    var date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    var s = store();

    var lines = ['Hello Craftier, I would like to book an appointment.', ''];

    if (state.type === 'store') {
      lines.push('Type: Visit a store');
      if (s) {
        lines.push('Store: ' + s.name);
        lines.push('Address: ' + s.address);
        if (s.maps) lines.push('Map: ' + s.maps);
      }
    } else {
      lines.push('Type: Live video call');
    }

    lines.push('');
    lines.push('Date: ' + longDate(date));
    lines.push('Time: ' + slotLabel(state.time));
    lines.push('');
    lines.push('Name: ' + name);
    lines.push('Mobile: +91 ' + phone);
    if (email) lines.push('Email: ' + email);
    if (occasion) lines.push('Occasion: ' + occasion);
    if (notes) lines.push('Notes: ' + notes);

    var title = root.dataset.crProduct;
    var url = root.dataset.crProductUrl;
    if (title || url) {
      lines.push('');
      if (title) lines.push('Piece: ' + title);
      if (url) lines.push(url);
    }

    var href = 'https://api.whatsapp.com/send/?phone=' + (CFG().whatsapp || '') +
               '&text=' + encodeURIComponent(lines.join('\n'));

    /* Capture server-side BEFORE handing off to WhatsApp. If we waited,
       a customer who closes WhatsApp without pressing send would leave
       no record at all — and this form is the richest data on the site.
       keepalive lets the request finish even as the tab changes. */
    var endpoint = CFG().bookingEndpoint;
    if (endpoint) {
      try {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({
            name: name,
            phone: '+91' + phone,
            email: email || null,
            occasion: occasion || null,
            notes: notes || null,
            type: state.type === 'store' ? 'Visit a store' : 'Live video call',
            store: s ? s.name : null,
            store_address: s ? s.address : null,
            store_maps: s ? s.maps : null,
            date: longDate(date),
            time: slotLabel(state.time),
            product: root.dataset.crProduct || null,
            url: root.dataset.crProductUrl || null,
            source: 'pdp_appointment',
            ts: new Date().toISOString()
          })
        }).catch(function () {});
      } catch (e) {}
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'craftier_appointment_booked',
      appointment_type: state.type,
      store: s ? s.name : null,
      date: state.date,
      occasion: occasion || null
    });
    if (typeof window.fbq === 'function') window.fbq('track', 'Schedule');

    say('Opening WhatsApp to confirm your booking\u2026', 'ok');
    window.open(href, '_blank', 'noopener');
    setTimeout(close, 900);
  }

  /* ---------- events (delegated from the modal root) ---------- */

  root.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-crb-close]')) return close();

    var type = t.closest('[data-crb-type]');
    if (type) return pickType(type.dataset.crbType);

    if (t.closest('[data-crb-back]')) {
      if (stepIndex > 0) stepIndex--;
      return render();
    }

    if (t.closest('[data-crb-next]')) {
      if (stepIndex < steps().length - 1) stepIndex++;
      return render();
    }

    if (t.closest('[data-crb-prev]')) {
      view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
      return renderCalendar();
    }
    if (t.closest('[data-crb-next-month]')) {
      view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
      return renderCalendar();
    }

    var day = t.closest('[data-crb-day]');
    if (day) {
      state.date = day.dataset.crbDay;
      state.time = null;
      renderCalendar();
      renderSlots();
      return syncNext();
    }

    var slot = t.closest('[data-crb-slot]');
    if (slot) {
      state.time = Number(slot.dataset.crbSlot);
      renderSlots();
      return syncNext();
    }

    if (t.closest('[data-crb-confirm]')) return confirm();
  });

  root.addEventListener('change', function (e) {
    if (e.target.closest('[data-crb-store]')) {
      state.storeId = e.target.value || null;
      showStoreCard();
      syncNext();
    }
  });

  /* Openers live in swappable Custom Liquid blocks, so delegate from document. */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-crb-open]');
    if (!opener) return;
    e.preventDefault();
    open(opener.dataset.crbOpen || null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });
})();
